/**
 * Play – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Play playback control. */
export default function PlayIcon({ focused, height, width }: Props) {
  return (
    <svg
      clipRule={'evenodd'}
      fill={focused ? Colors['dark'] : Colors['light']}
      fillRule={'evenodd'}
      height={`${height || 32 * Screen.widthRatio}`}
      width={`${width || 37 * Screen.widthRatio}`}
      xmlns={'http://www.w3.org/2000/svg'}
      viewBox={'0 0 32 37'}
    >
      <path d='M1.95245 0.656763C3.15651 -0.126876 4.77499 -0.275369 6.19794 0.574333L6.19977 0.575427L30.0912 14.8746C30.0913 14.8747 30.0914 14.8748 30.0916 14.8749C31.4171 15.668 32 17.0592 32 18.314C32 19.5688 31.4171 20.9601 30.0916 21.7532C30.0914 21.7532 30.0913 21.7533 30.0912 21.7534L6.19977 36.0526L6.19794 36.0537C4.77499 36.9034 3.15651 36.7549 1.95245 35.9713C0.76633 35.1993 0 33.8395 0 32.2887L0 4.33937C0 2.78851 0.76633 1.42873 1.95245 0.656763ZM4.24444 4.35171L4.24444 32.2763L27.573 18.314L4.24444 4.35171ZM27.9118 18.1112C27.912 18.1111 27.9121 18.111 27.9123 18.1109L27.9118 18.1112ZM27.9123 18.5171C27.9121 18.517 27.912 18.5169 27.9118 18.5168L27.9123 18.5171Z'></path>
    </svg>
  );
}
